export default "//file.bilionpass.com/japandx-portal/0.1.15/static/img/plane-orange.b3ffb482-1c4b52.svg";